/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemRoomArTrackableDefinitionMarker3dFromJSON(json) {
    return StreemRoomArTrackableDefinitionMarker3dFromJSONTyped(json, false);
}
export function StreemRoomArTrackableDefinitionMarker3dFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': !exists(json, 'file') ? undefined : json['file'],
    };
}
export function StreemRoomArTrackableDefinitionMarker3dToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': value.file,
    };
}
//# sourceMappingURL=StreemRoomArTrackableDefinitionMarker3d.js.map